import React from 'react';
import WrapperValidationInputGroup from "./WrapperValidationInputGroup";
import {InputGroup} from "../base/InputGroup";
import {RequiredValidator} from "../../validator/RequiredValidators";
import PropTypes from "prop-types";
import {FullNameValidator} from "../../validator/FullNameValidator";

class Required extends React.Component {
    render() {
        return (
            <InputGroup autoFocus={this.props.autoFocus} input={this.props.input} alert={this.props.alert} onChange={this.props.onChange}
                        onBlur={this.props.onBlur}/>
        )
    }
}

let listValidators = () => {
    let validators = [];
    validators.push(new RequiredValidator());
    validators.push(new FullNameValidator());
    return validators;
};

const validators = {
    validators: listValidators()
};

export const FullNameInputGroup = WrapperValidationInputGroup(Required, validators);

FullNameInputGroup.propTypes = {
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
    }),
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    validateOn: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/input/validation/FullNameInputGroup.js